import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  text: {
    paddingRight: theme.spacing(0.25)
  },
  completedText: {
    paddingLeft: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1)
    }
  },
  light: {
    color: theme.palette.secondary[500]
  },
  dark: {
    color: "inherit"
  }
}));

export default function ActivitiesCompleted(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box
      data-qa="course-activities-completed"
      display="flex"
      pb={1}
      fontSize={props.fontSize}
    >
      <Typography
        variant="inherit"
        className={`${classes.text} ${classes.dark}`}
      >
        {props.completedSteps}
      </Typography>
      <Typography
        variant="inherit"
        className={`${classes.text} ${classes.light}`}
      >
        /
      </Typography>
      <Typography
        variant="inherit"
        className={`${classes.text} ${classes.dark}`}
      >
        {props.totalSteps}
      </Typography>
      <Typography
        variant="inherit"
        className={`${classes.completedText} ${classes.light}`}
      >
        {t("activitiesCompleted.shortCousesCompleted")}
      </Typography>
    </Box>
  );
}

ActivitiesCompleted.propTypes = {
  fontSize: PropTypes.string,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number
};

ActivitiesCompleted.defaultProps = {
  fontSize: "0.75rem"
};
